import { Signup } from '../../../features/auth/signup';
import './auth.css';

const SignupPage = () => {
  return (
    <div>
      <Signup />
    </div>
  );
};

export { SignupPage };
